/**
 * React context and consumer hook for the single-order data accumulator.
 * @module dataAccumulator/DataAccumulatorContext
 */
import { createContext, useContext } from "react";
import { defaultDataAccumulatorContextValue } from "./defaultContextValue";
import { DataAccumulatorContextValue } from "./types";

/** React context holding all single-order Postgres domain fetch state. */
export const DataAccumulatorContext =
  createContext<DataAccumulatorContextValue>(
    defaultDataAccumulatorContextValue,
  );

/**
 * Convenience hook to consume the data-accumulator context.
 *
 * @returns The current {@link DataAccumulatorContextValue}
 */
export const useDataAccumulatorForSingleOrder = () =>
  useContext(DataAccumulatorContext);
